import { Component } from "react"
import classNames from "classnames"
import PropTypes from "prop-types"

class LegendItem extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    color: PropTypes.string.isRequired,
    focus: PropTypes.func.isRequired,
    blur: PropTypes.func.isRequired,
    focused: PropTypes.string,
    isLastLegendItem: PropTypes.bool,
  }

  onEnter = () => {
    const { id, focus } = this.props
    focus(id)
  }

  onLeave = () => {
    const { blur } = this.props
    blur()
  }

  render() {
    const { disabled, color, label, focused, id, isLastLegendItem } = this.props

    return <div
      onClick={this.onClick}
      onMouseEnter={this.onEnter}
      onMouseLeave={this.onLeave}
      className={classNames(
        "focus-enabled",
        focused && focused === id && "visible",
        focused && focused !== id && "hidden",
        disabled && "disabled",
      )}
      id={isLastLegendItem ? "last-compare-label" : null}
    >
      <div className="color" style={{ backgroundColor: color, borderColor: color }} />
      <div className={classNames("label", { ellipsable: isLastLegendItem })} title={label}>{label}</div>
    </div>
  }
}

export default LegendItem
